import { useDealsStore } from './deals'
import { useContactsStore } from './contacts'
import { useCompaniesStore } from './companies'
import { useActivitiesStore } from './activities'
import { useNotesStore } from './notes'
import { usePipelinesStore } from './pipelines'
import { useProductsStore } from './products'
import { useDealLineItemsStore } from './dealLineItems'
import { useNotificationStore } from './notifications'
import { useNotificationCenterStore } from './notificationCenter'
import { useOutreachStore } from './outreach'
import { useUsersStore } from './users'
import { useSubscriptionsStore } from './subscriptions'
import { useAuditLogsStore } from './auditLogs'
import { useCsvStore } from './csv'
import { useAdminStore } from './admin'
import { useWhatsappStore } from './whatsapp'
import { useInboxStore } from './inbox'

/**
 * Drop all per-organization cached data so switching orgs doesn't leak one org's
 * data into another. Intentionally excludes `auth` (manages the active org) and
 * `ui` (user-level UI prefs that aren't org-scoped). Relies on the $reset added
 * by reset-plugin.ts. Must be called with an active Pinia (e.g. from a component
 * or after the store has been used).
 */
export function resetUserScopedStores(): void {
  const stores = [
    useDealsStore(),
    useContactsStore(),
    useCompaniesStore(),
    useActivitiesStore(),
    useNotesStore(),
    usePipelinesStore(),
    useProductsStore(),
    useDealLineItemsStore(),
    useNotificationStore(),
    useNotificationCenterStore(),
    useOutreachStore(),
    useUsersStore(),
    useSubscriptionsStore(),
    useAuditLogsStore(),
    useCsvStore(),
    useAdminStore(),
    useWhatsappStore(),
    // Unified inbox rows and the nav badge's waiting counts (MainLayout refetches them after the switch).
    useInboxStore(),
  ]
  for (const store of stores) {
    try {
      ;(store as unknown as { $reset?: () => void }).$reset?.()
    } catch {
      // best-effort
    }
  }
  // The inbox counts' debounce timer and request sequence live outside the store's state: drop
  // them too, so an answer still in flight for the old org never lands in the new org's badge.
  try {
    useInboxStore().resetCounts()
  } catch {
    // best-effort
  }
}
